/**
 * Collections page
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Global from "./lib/global";

// Vars
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = "Global";

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

/**
 * init - Initialize the page
 **/

// Quantity randoms
document.addEventListener("DOMContentLoaded", () => {
	let unitPrice = document.querySelectorAll(".unit-text.random");
	const listRandomProducts = localStorage.getItem("random-product");


	const productContent = document.querySelector('#ProductGridContainer')
	const remainingStep = window.remainingStep;
	const textRandom = window.textRandom;
	const remaining = window.remaining;

	let currentTime = new Date();

	const validateHour = (dateIni) => {
		const newDate = new Date();
		const oldDate = new Date(dateIni);
		const diff = newDate - oldDate;
		const diffHour = diff / (1000 * 60 * 60);
		if (diffHour > 1) {
			currentTime = newDate;
		}
		return diffHour;
	};

	const randomProduct = listRandomProducts ? JSON.parse(listRandomProducts).products : [];


	const remainingStepObj = Object.entries(remainingStep);

	let remainingMap = remainingStepObj.map(([prop, value]) => {
		return value > 0 ? value : null;
	});

	const TEXTS_STEP = {
		step_1: textRandom[0],
		step_2: textRandom[1],
		step_3: textRandom[2],
		reset_stock: textRandom[3],
	};

	function objDiff(param) {
		if (param <= remainingMap[0]) {
			return TEXTS_STEP["step_1"];
		} else if (param <= remainingMap[1]) {
			return TEXTS_STEP["step_2"];
		} else if (param <= remainingMap[2]) {
			return TEXTS_STEP["step_3"];
		} else {
			return TEXTS_STEP["reset_stock"];
		}
	}

	/* updateLocal solo se usara para cuando exista, para insertarlo la primera vez no se debe hacer nada */
	const randomLogic = (param = 3, exists = false, updateLocal = false) => {
		unitPrice.forEach((element) => {
			const wrapperContent = element.closest(".unit");
			const wrapperProduct = wrapperContent.closest(".card-information");
			const unitProgress = wrapperContent.querySelector(".progress_bar.random > div");
			const productId = wrapperProduct.querySelector(".product_id_units").id;

			let randomRemaining = Math.floor(Math.random() * remaining) - param;

			if (exists) {
				const { lastHour } = JSON.parse(listRandomProducts);
				const findProduct = randomProduct.find(
					(product) => product.productId === productId
				);

				if(!findProduct){
					randomProduct.push({
						productId: productId,
						progressBar: randomRemaining,
					});
				} else {
					const { progressBar } = findProduct;
					if(updateLocal){
						randomRemaining = progressBar - param;
						findProduct.progressBar = randomRemaining;
					}else {
						randomRemaining = progressBar;
					}
				}
				
				currentTime = lastHour;
			} else {
				randomProduct.push({
					productId: productId,
					progressBar: randomRemaining,
				});
			}

			if (randomRemaining <= 0) {
				randomRemaining = remaining;
			}

			unitProgress.style.width = `${randomRemaining}%`;
			element.innerHTML = objDiff(randomRemaining);

		});
		localStorage.setItem("random-product", JSON.stringify({
			lastHour: currentTime, 
			products: randomProduct, 
			minusProduct: param
		}));
	};

	if (!listRandomProducts) {
		randomLogic();
	} else {
		let { lastHour } = JSON.parse(listRandomProducts);
		let diffHour = validateHour(lastHour);

		if (diffHour > 1) {
			randomLogic(3, true, true);
		}else{
			randomLogic(0, true, false);
		}
	}

	const mutationGrid = new MutationObserver((mutations) => {
		mutations.forEach(mutation => {
			if(mutation.addedNodes.length > 0){
				unitPrice = document.querySelectorAll(".unit-text.random")
				randomLogic(0, true, false);
			}
		});
	})

	mutationGrid.observe(productContent, { attributes: false, childList: true, subtree: false});
});
